import { Component, OnInit } from '@angular/core';
import { appVersion } from '../app.version'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  version: string
  copyright: string;

  constructor() {

  }

  ngOnInit() {
    this.version = appVersion
    let year = new Date().getFullYear().toString();
    this.copyright = year + " @ Certisign Certificadora Digital";
  }
}